import request from '../../http/request'

export const getDashboardTag = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc/v1/api/dashboard/tag`, { params, noSpin: true })
}

export const getDashboardJob = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc/v1/api/dashboard/job`, { params, noSpin: true })
}

export const getDashboardIndicator = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc/v1/api/dashboard/api/indicator`, { params, noSpin: true })
}

export const getAPILogList = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v1/api/dashboard/api/log/list`, params)
}

export const getAPILogListWms = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v1/api/dashboard/api/log/list_wsm`, params)
}

export const getAPITaskRetry = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v1/api/dashboard/api/task/retry`, params, {
    noSpin: true
  })
}
export const getAPITaskRetryNotLX = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc-service/v1/dashboard/task/retry`, params, {
    noSpin: true
  })
}

export const dashboardPayloadDownload = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc/v1/api/dashboard/api/task/payload/download`, {
    params,
    responseType: 'blob',
    uploadOrDownload: true
  })
}
